import { v4 } from 'uuid';

export function generateRuid(): string {
  return v4();
}
